<template>
  <div class="login_page">

    <div class="login_page_content">
      <div class="authorize_card" v-show="token">
        <div class="content">
          <p class="tip">检测到您已登录 INFO X MED 官网</p>
          <p class="tip">请点击下方按钮完成一键授权登录</p>
          <div class="authorize_btn dfc hand_btn" @click="authorizeToken">
            授权登录
          </div>
        </div>
      </div>
      <LoginContent v-if="!token" :isShowLogin="isShowLogin" :loginCallBack="loginCallBack" />
    </div>

  </div>
</template>

<script>
import LoginContent from '@/components/login/loginContent.vue'
import { getToken, setToken } from '@/utils/storage.js'

export default {
  props: {},
  components: {
    LoginContent

  },
  data () {
    return {
      isShowLogin: true,
      token: getToken()
    }
  },
  methods: {
    authorizeToken () {
      this.$message.success('登录成功')
      this.pushToken()
    },
    pushToken () {
      setToken(this.token)
      window.parent.postMessage({
        key: 'pushToken',
        data: this.token
      }, '*')
    },
    loginCallBack () {
      this.token = getToken()
      this.pushToken()
    }
  },
  created () {
    if (!this.token) {
      this.isShowLogin = true
    }
    if (this.token) {
      // 校验token有效性
      this.$store.dispatch('user/actionsGetUserInfo', this.token)
    }
  }
}
</script>

<style lang="less" scoped>
.login_page {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: transparent;
}

.login_page_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 730px;
  height: 478px;
}

.authorize_card {
  display: grid;
  grid-template-columns: 330px 1fr;
  min-height: 478px;
  width: 100%;
  background: url('https://img.infox-med.com/webImg/infoPc/login/login_bg.png')
    no-repeat;
  background-size: 100% calc(100% - 10px);
  background-position: 0 10px;
  .content {
    position: relative;
    grid-column-start: 2;
    grid-column-end: 3;
    background-color: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .tip {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .authorize_btn {
    margin-top: 40px;
    width: 200px;
    height: 40px;
    background-color: #4b639f;
    border-radius: 20px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 2px;
  }
}
</style>
